import { Outlet, Link, useNavigate } from 'react-router-dom';
import { useState, useRef, useEffect } from 'react';
import './Home.css';
import Logo from '../assets/images/Logo.png';
import UserIcon from '../assets/images/user.png';
import ScrollToTop from './ScrollToTop'; // 👈 Asegúrate que la ruta sea correcta

function Home() {
  const [showLoginMenu, setShowLoginMenu] = useState(false);
  const [showServiciosMenu, setShowServiciosMenu] = useState(false);
  const [showLoginSubmenuSidebar, setShowLoginSubmenuSidebar] = useState(false);
  const [showServiciosSubmenuSidebar, setShowServiciosSubmenuSidebar] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);
  const navigate = useNavigate();
  const loginMenuRef = useRef(null);
  const serviciosMenuRef = useRef(null);

  useEffect(() => {
    const user = localStorage.getItem("user");
    setIsLoggedIn(!!user);
  }, []);

  const toggleLoginMenu = () => setShowLoginMenu(prev => !prev);
  const toggleServiciosMenu = () => setShowServiciosMenu(prev => !prev);
  const toggleLoginSubmenuSidebar = () => setShowLoginSubmenuSidebar(prev => !prev);
  const toggleServiciosSubmenuSidebar = () => setShowServiciosSubmenuSidebar(prev => !prev);

  const goToLogin = () => {
    setShowLoginMenu(false);
    setShowSidebar(false);
    setShowLoginSubmenuSidebar(false);
    setShowServiciosSubmenuSidebar(false);
    navigate("/login");
  };

  const goToRegister = () => {
    setShowLoginMenu(false);
    setShowSidebar(false);
    setShowLoginSubmenuSidebar(false);
    setShowServiciosSubmenuSidebar(false);
    navigate("/register");
  };

  const goToProfile = () => {
    setShowLoginMenu(false);
    setShowSidebar(false);
    setShowLoginSubmenuSidebar(false);
    setShowServiciosSubmenuSidebar(false);
    navigate("/profile");
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setIsLoggedIn(false);
    setShowLoginMenu(false);
    setShowSidebar(false);
    setShowLoginSubmenuSidebar(false);
    setShowServiciosSubmenuSidebar(false);
    navigate("/");
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (loginMenuRef.current && !loginMenuRef.current.contains(event.target)) {
        setShowLoginMenu(false);
      }
      if (serviciosMenuRef.current && !serviciosMenuRef.current.contains(event.target)) {
        setShowServiciosMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSidebarNavigate = (path) => {
    setShowSidebar(false);
    setShowLoginSubmenuSidebar(false);
    setShowServiciosSubmenuSidebar(false);
    navigate(path);
  };

  return (
    <div>
      {/*Bloque cabecera*/}
      <nav className="navbar">
        <div className="navbar-content">
          {/* Logotipo */}
          <Link to="/">
            <img src={Logo} alt="Logo" className="navbar-logo" />
          </Link>

          {/* Botón hamburguesa */}
          <button
            className="hamburger-btn"
            onClick={() => setShowSidebar(!showSidebar)}
            aria-label="Toggle menu"
          >
            &#9776;
          </button>

          <ul className="navbar-list">
            {/*Sección IAutomatiza CFDI */}
            <li><Link to="/">IAutomatiza CFDI</Link></li>
            {/*Sección Facturación Electrónica*/}
            <li><Link to="/Facturacion">Facturación Electrónica</Link></li>
            {/*Sección Servicios*/}
            <li><Link to="/Servicios">Servicios</Link></li>
            {/*Sección Nosotros*/}
            <li><Link to="/Nosotros">Sobre Nosotros</Link></li>
            {/*Botón de login */}
            <li ref={loginMenuRef} style={{ position: 'relative', marginLeft: 'auto' }}>
              {!isLoggedIn ? (
                
  <button
    className="login-button"
    onClick={() => window.location.href = 'https://iautomatizacloud.com/'}
  >
    Iniciar sesión
    <img src={UserIcon} alt="User Icon" className="user-icon" />
  </button>
) : (
                <>
                  <button className="login-button" onClick={toggleLoginMenu}>
                    Menú
                  </button>
                  {showLoginMenu && (
                    <div className="login-menu">
                      <button onClick={goToProfile}>Perfil</button>
                      <button onClick={handleLogout}>Cerrar sesión</button>
                    </div>
                  )}
                </>
              )}
            </li>
          </ul>
        </div>
      </nav>

      <div className={`sidebar ${showSidebar ? 'show' : ''}`}>
        <button className="close-btn" onClick={() => setShowSidebar(false)}>&times;</button>
        <nav className="sidebar-nav">
          <Link onClick={() => handleSidebarNavigate("/")} to="/">IAutomatiza CFDI</Link>
          <Link onClick={() => handleSidebarNavigate("/Facturacion")} to="/Facturacion">Facturación Electrónica</Link>
          <Link onClick={() => handleSidebarNavigate("/Servicios")} to="/Servicios">Servicios</Link>
          <Link onClick={() => handleSidebarNavigate("/Nosotros")} to="/Nosotros">Sobre Nosotros</Link>

          {!isLoggedIn ? (
  <button onClick={() => window.location.href = 'https://iautomatizacloud.com/'}>Iniciar sesión</button>
) : (
            <>
              <button onClick={toggleLoginSubmenuSidebar}>
                Menú <img src={UserIcon} alt="User Icon" className="user-icon" />
              </button>
              {showLoginSubmenuSidebar && (
                <div className="sidebar-login-submenu">
                  <button onClick={goToProfile}>Perfil</button>
                  <button onClick={handleLogout}>Cerrar sesión</button>
                </div>
              )}
            </>
          )}
        </nav>
      </div>

      <main className="main-content">
        <ScrollToTop /> {/* 👈 Scroll automático al cambiar ruta */}
        <Outlet />
      </main>
    </div>
  );
}

export default Home;

